import auth, { getAuthData } from './auth';
import emailVerificationData from './emailVerification';
import languageReady from './i18n';
import {
  isAuthorized,
  SetBranding,
  SET_BRANDING,
  SetInitialized,
  SET_INITIALIZED,
  SET_NOTE_FROM_REFERRER,
  NoteFromReferrer
} from '../actions';
import { StoreState, InitializationState } from '../types';
import { createSelector } from 'reselect';

const reducers = {
  initialized,
  branding,
  languageReady,
  noteFromReferrer
};

export default {
  ...auth,
  ...emailVerificationData,
  ...reducers
};

export * from './auth';

// reducers ------------------------------------------------------------------

export function initialized(
  state: StoreState['initialized'] = false,
  action: SetInitialized
) {
  switch (action.type) {
    case SET_INITIALIZED:
      return action.initialized;
    default:
      return state;
  }
}

export function branding(state: StoreState['branding'], action: SetBranding) {
  switch (action.type) {
    case SET_BRANDING:
      return action.branding || null;
    default:
      return state || null;
  }
}

export function noteFromReferrer(
  state: StoreState['noteFromReferrer'],
  action: NoteFromReferrer
) {
  switch (action.type) {
    case SET_NOTE_FROM_REFERRER:
      return action.noteFromReferrer || null;
    default:
      return state || null;
  }
}

// selectors -----------------------------------------------------------------

export function getInitialized(state: StoreState) {
  return state.initialized;
}

export function getBranding(state: StoreState) {
  return state.branding;
}

export function getNoteFromReferrer(state: StoreState) {
  return state.noteFromReferrer;
}

export const getExternalLoginUrl = createSelector(getBranding, (data) => {
  return data ? data.externalLoginUrl : undefined;
});

export const getAppState = createSelector(
  getAuthData,
  getInitialized,
  (authData, isInitialized): InitializationState => {
    return !isInitialized
      ? InitializationState.loading
      : isAuthorized(authData)
      ? InitializationState.authorized
      : InitializationState.unauthorized;
  }
);
